import { If } from "react-conditional-components-renderer";

import AscChallenge from "./AscChallenge/AscChallenge";
import AscReflection from "./AscReflection/AscReflection";
import AscDigDeeper from "./AscDigDeeper/AscDigDeeper";
import { AdminChallenge } from "@ascendnow/shared";

export interface AscContentTabsProps {
  tabId: string;
  challenges?: AdminChallenge[];
}

export default function AscContentTabs({
  tabId,
  challenges,
}: AscContentTabsProps) {
  return (
    <div>
      <If test={tabId === "dig-deeper"}>
        <AscDigDeeper />
      </If>

      <If test={tabId === "reflection"}>
        <AscReflection />
      </If>

      <If test={tabId === "challenge"}>
        <AscChallenge challenges={challenges} />
      </If>
    </div>
  );
}
